// Converts the raw pause_reason string from the abuse system into
// human-friendly text. The raw string looks like:
//   "complaint 0.055% > 0.05%"
//   "bounce 6.20% > 5%; complaint 0.120% > 0.1%"
//   "volume 12.5x > 10x"

const REASON_MAP: Record<string, string> = {
  bounce: 'High bounce rate detected',
  complaint: 'High complaint rate detected',
  volume: 'Unusual volume spike detected',
  'spam trap': 'Spam trap hits detected',
  'serial offender': 'Repeated policy violations',
  'stale warning': 'Metrics did not recover in time',
}

export function humanizeReason(raw: string | null | undefined): string {
  if (!raw) return 'Unusual sending activity detected.'

  const parts: string[] = []
  for (const [keyword, label] of Object.entries(REASON_MAP)) {
    if (raw.toLowerCase().includes(keyword)) {
      parts.push(label)
    }
  }

  return parts.length > 0 ? parts.join('. ') + '.' : 'Unusual sending activity detected.'
}
